import { render, staticRenderFns } from "./AtcomTable.vue?vue&type=template&id=39056a72&scoped=true"
import script from "./AtcomTable.ts?vue&type=script&lang=ts&external"
export * from "./AtcomTable.ts?vue&type=script&lang=ts&external"
import style0 from "./AtcomTable.vue?vue&type=style&index=0&id=39056a72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39056a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39056a72')) {
      api.createRecord('39056a72', component.options)
    } else {
      api.reload('39056a72', component.options)
    }
    module.hot.accept("./AtcomTable.vue?vue&type=template&id=39056a72&scoped=true", function () {
      api.rerender('39056a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/History/components/AtcomTable/AtcomTable.vue"
export default component.exports